<script lang="ts">
	import { RanksModal } from '@infinitro/about-vip';
	import { AuthModal, WelcomeModal } from '@infinitro/auth';
	import { BetSlipModal } from '@infinitro/bet-feed';
	import { cfgStage, Stage } from '@infinitro/config';
	import { DevSettings, ProdSettings } from '@infinitro/dev_modals';
	import { EmailVerifyModal } from '@infinitro/email_verify';
	import { GameInfoModal } from '@infinitro/game-page';
	import { GeoBlock, Maintenance } from '@infinitro/geoblock';
	import { loggedIn, ModalDialog, modalStack, stateOpenModal } from '@infinitro/global';
	import { LoadingManager } from '@infinitro/loading';
	import { LuckyDip as LuckyDipModal } from '@infinitro/lucky-dip';
	import { ErrorModal, LoadingModal } from '@infinitro/modal';
	import { UpdateModal } from '@infinitro/notifications';
	import { SearchModal } from '@infinitro/sidebar';
	import { Modal as TotpSetup } from '@infinitro/totp_setup';
	import { Modal as TotpVerify } from '@infinitro/totp_verify';
	import { WalletVerifyModal } from '@infinitro/wallet_verify';
</script>

<div class="modals">
	<LoadingManager customClass="fixed-loading-screen" waitForLoggedIn={true} />
	{#if (!$loggedIn && $stateOpenModal && [ModalDialog.Auth, ModalDialog.Login, ModalDialog.Signup].includes($stateOpenModal)) || $modalStack.some( (e) => [ModalDialog.Auth, ModalDialog.Login, ModalDialog.Signup].includes(e.modal) )}
		<AuthModal />
	{/if}
	{#if $stateOpenModal === ModalDialog.BetSlip || $modalStack.some((e) => e.modal === ModalDialog.BetSlip)}
		<BetSlipModal />
	{/if}
	{#if $stateOpenModal === ModalDialog.DevSettings || $modalStack.some((e) => e.modal === ModalDialog.DevSettings)}
		{#if cfgStage() === Stage.Prod}
			<ProdSettings />
		{:else}
			<DevSettings />
		{/if}
	{/if}
	{#if $stateOpenModal === ModalDialog.GameInfo || $modalStack.some((e) => e.modal === ModalDialog.GameInfo)}
		<GameInfoModal />
	{/if}
	{#if $stateOpenModal === ModalDialog.Search || $modalStack.some((e) => e.modal === ModalDialog.Search)}
		<SearchModal />
	{/if}
	{#if $stateOpenModal === ModalDialog.Update || $modalStack.some((e) => e.modal === ModalDialog.Update)}
		<UpdateModal />
	{/if}
	{#if $stateOpenModal === ModalDialog.VipClub || $modalStack.some((e) => e.modal === ModalDialog.VipClub)}
		<RanksModal />
	{/if}
	{#if $stateOpenModal === ModalDialog.WelcomeModal || $modalStack.some((e) => e.modal === ModalDialog.WelcomeModal)}
		<WelcomeModal />
	{/if}
	{#if $stateOpenModal === ModalDialog.LuckyDip || $modalStack.some((e) => e.modal === ModalDialog.LuckyDip)}
		<LuckyDipModal />
	{/if}
	{#if $stateOpenModal === ModalDialog.Geoblock || $modalStack.some((e) => e.modal === ModalDialog.Geoblock)}
		<GeoBlock />
	{/if}
	{#if $stateOpenModal === ModalDialog.Maintenance || $modalStack.some((e) => e.modal === ModalDialog.Maintenance)}
		<Maintenance />
	{/if}
	{#if $stateOpenModal === ModalDialog.WalletVerify || $modalStack.some((e) => e.modal === ModalDialog.WalletVerify)}
		<WalletVerifyModal />
	{/if}
	{#if $stateOpenModal === ModalDialog.Loading || $modalStack.some((e) => e.modal === ModalDialog.Loading)}
		<LoadingModal />
	{/if}
	{#if $stateOpenModal === ModalDialog.EmailVerify || $modalStack.some((e) => e.modal === ModalDialog.EmailVerify)}
		<EmailVerifyModal />
	{/if}
	{#if $stateOpenModal === ModalDialog.TotpVerify || $modalStack.some((e) => e.modal === ModalDialog.TotpVerify)}
		<TotpVerify />
	{/if}
	{#if $stateOpenModal === ModalDialog.TotpSetup || $modalStack.some((e) => e.modal === ModalDialog.TotpSetup)}
		<TotpSetup />
	{/if}
	{#if $stateOpenModal === ModalDialog.Error || $modalStack.some((e) => e.modal === ModalDialog.Error)}
		<ErrorModal />
	{/if}
</div>

<style lang="postcss">
	.modals {
		z-index: 61;
	}
</style>
